export const selectResources = state => {
    return state.resources
  }